export default __webpack_public_path__ + "static/media/food.c05c1e06.png";